import React, { useRef, useState, useEffect } from 'react';
import './input.css';

export default function CodeAuthField({
    callback,
    reset,
    isLoading,
    codeLength = 6
}) {
    const [code, setCode] = useState('');

    // Refs to control each digit input element
    const inputRefs = Array.from({ length: codeLength }, () => useRef(null));

    // Reset all inputs and clear state
    const resetCode = () => {
        inputRefs.forEach((ref) => {
            ref.current.value = '';
        });
        inputRefs[0].current.focus();
        setCode('');
    };

    // Call our callback when code = codeLength
    useEffect(() => {
        if (code.length === codeLength) {
            if (typeof callback === 'function') callback(code);
            resetCode();
        }
    }, [code]); //eslint-disable-line

    // Listen for external reset toggle
    useEffect(() => {
        resetCode();
    }, [reset]); //eslint-disable-line

    // Handle input
    function handleInput(e, index) {
        const input = e.target;
        const previousInput = inputRefs[index - 1];
        const nextInput = inputRefs[index + 1];

        // Update code state with single digit
        const newCode = [...code];
        // Convert lowercase letters to uppercase
        // if (/^[a-z]+$/.test(input.value)) {
        //     const uc = input.value.toUpperCase();
        //     newCode[index] = uc;
        //     inputRefs[index].current.value = uc;
        // } else {
        //     newCode[index] = input.value;
        // }
        newCode[index] = input.value;
        setCode(newCode.join(''));

        input.select();

        if (input.value === '') {
            // If the value is deleted, select previous input, if exists
            if (previousInput) {
                previousInput.current.focus();
            }
        } else if (nextInput) {
            // Select next input on entry, if exists
            nextInput.current.select();
        }
    }

    // Select the contents on focus
    function handleFocus(e) {
        e.target.select();
    }

    // Handle backspace key
    function handleKeyDown(e, index) {
        const input = e.target;
        const previousInput = inputRefs[index - 1];
        // const nextInput = inputRefs[index + 1];

        if ((e.keyCode === 8 || e.keyCode === 46) && input.value === '') {
            e.preventDefault();
            setCode(
                (prevCode) =>
                    prevCode.slice(0, index) + prevCode.slice(index + 1)
            );
            if (previousInput) {
                previousInput.current.focus();
            }
        }
    }

    // Capture pasted characters
    const handlePaste = (e) => {
        const pastedCode = e.clipboardData
            .getData('text/plain')
            .slice(0, codeLength);
        setCode(pastedCode);
        inputRefs.forEach((inputRef, index) => {
            inputRef.current.value = pastedCode.charAt(index);
        });
    };

    return (
        <div className="flex gap-1 relative">
            {Array.from({ length: codeLength }, (_, index) => index).map(
                (index) => (
                    <input
                        // className="text-2xl bg-gray-100 w-10 flex border-2 border-gray-100 p-2 text-center "
                        className="custom-input border rounded-2xl"
                        key={index}
                        type="text"
                        maxLength={1}
                        onChange={(e) => handleInput(e, index)}
                        ref={inputRefs[index]}
                        value={code[index] || ''}
                        autoFocus={index === 0}
                        onFocus={handleFocus}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        onPaste={handlePaste}
                        disabled={isLoading}
                    />
                )
            )}
        </div>
    );
}
